import { queryOptions } from '@tanstack/react-query';
import type {
  GetDuoSummaryData,
  GetDuoSummaryResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';
import type { ReplacePathParams } from '@/shared/utils/pathParams';

export interface DuoSummaryKeyParams {
  userId: string;
}

const getDuoSummaryUrl = (
  userId: string,
): ReplacePathParams<GetDuoSummaryData['url']> =>
  `users/${userId}/duos/summary`;

export const getDuoSummaryKey = ({ userId }: DuoSummaryKeyParams) =>
  ['duo-summary', userId] as const;

export const getDuoSummaryOptions = (params: DuoSummaryKeyParams) =>
  queryOptions({
    queryKey: getDuoSummaryKey(params),
    queryFn: async ({ signal }) =>
      PrivateApi.get(getDuoSummaryUrl(params.userId), {
        signal,
      }).json<GetDuoSummaryResponse>(),
  });
